"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
class ImageVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", ImageVariable.settings);
    (0, _defineProperty2.default)(this, "type", "image");
    (0, _defineProperty2.default)(this, "label", "Image");
    (0, _defineProperty2.default)(this, "description", "Load an image into a variable.");
  }
  dependencies(params, resolver) {
    let uri = resolver.resolveString(params.uri);
    return {
      uri
    };
  }
  async value(deps, batcher) {
    if (!(deps !== null && deps !== void 0 && deps.uri)) {
      return null;
    }
    let {
      uri
    } = deps;
    if (uri.startsWith("ipfs://")) {
      uri = "https://gateway.ipfs.io/ipfs/" + uri.slice(7);
    }
    return uri;
  }
}
exports.ImageVariable = ImageVariable;
(0, _defineProperty2.default)(ImageVariable, "settings", {
  uri: {
    type: "var",
    variableType: "value",
    title: "Image URI",
    description: "The link or URI for the image."
  }
});
//# sourceMappingURL=ImageVariable.js.map